import { ProviderSource } from '../types/template';
import { PROVIDER_CONFIG } from './providerConfig';
import { TEMPLATE_ORIGIN } from './template';

/** Gempages V7 */
export const regexTemplateV7 = new RegExp(
  `^templates/(${TEMPLATE_ORIGIN.join('|')})\\.(gp-template-\\d+)\\.(json|liquid)$`,
);
export const regexTemplateIdV7 = new RegExp('.*?gp-template-(.+?)(?:\\.(.*?))?$');

/** Gempages V6 */
export const regexTemplateV6 = new RegExp(
  `^templates/(${TEMPLATE_ORIGIN.join('|')})\\.(gem-\\d+-template)\\.(json|liquid)$`,
);
export const regexTemplateIdV6 = new RegExp('.*?gem-(.+?)-template(?:\\.(.*?))?$');

export const regexTemplateGemX = new RegExp(
  `^templates/(${TEMPLATE_ORIGIN.join('|')})\\.(${
    PROVIDER_CONFIG[ProviderSource.SHOPIFY_GEMX].prefix
  }.+?)\\.(json|liquid)$`,
);
export const regexTemplatePageFly = new RegExp(
  `^templates/(${TEMPLATE_ORIGIN.join('|')})\\.(${
    PROVIDER_CONFIG[ProviderSource.SHOPIFY_PAGE_FLY].prefix
  }.+?)\\.(json|liquid)$`,
);

export const regexTemplateFoxify = new RegExp(
  `^templates/(${TEMPLATE_ORIGIN.join('|')})\\.(${
    PROVIDER_CONFIG[ProviderSource.SHOPIFY_FOXIFY].prefix
  }.+?)\\.(json|liquid)$`,
);

export const regexTemplateEComposer = new RegExp(
  `^templates/(${TEMPLATE_ORIGIN.join('|')})\\.(${
    PROVIDER_CONFIG[ProviderSource.SHOPIFY_ECOMPOSER].prefix
  }.+?)\\.(json|liquid)$`,
);

export const regexTemplateOrigin = new RegExp(`^templates/(${TEMPLATE_ORIGIN.join('|')})\\.(json|liquid)$`);

export const regexTemplateShopify = new RegExp(`^templates/(${TEMPLATE_ORIGIN.join('|')})\\.(.+?)\\.(json|liquid)$`);

export const TEMPLATE_IGNORE = ['gem-backup-default', 'gp-template-bk-default'];

export const regexTemplateIgnore = new RegExp(
  `templates/(${TEMPLATE_ORIGIN.join('|')}).(${TEMPLATE_IGNORE.join('|')}).(json|liquid)`,
);
